module.exports = __webpack_public_path__ + "static/img/articleguest.9cb2ebc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/propaganda/articleguest.jpg
// module id = 8ncb
// module chunks = 1